module.exports = __webpack_public_path__ + "img/zxsign5.d504ffa0.png";